import React, { useEffect, useState } from 'react';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import TextInput from '../../Common/TextInput';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxUser from '../../../util/remote/ajaxUser';

const PopChangeUserRole = () => {
    const [roleId, setRoleId] = useState(null);
    const {getUserRoles, userRoles, modifiedUser, setModifiedUser} = useConfig();
    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    useEffect(() => {
        getUserRoles(); // Fetch user roles when the modal is shown
    }, []);
    
     
    const handleConfirm = async() => {
        setLoading(true);
        const payload = {
            role_id: roleId,
            user_id: modifiedUser.user.user_id
        };
        const server_response = await ajaxUser.updateUserRole(payload);
        setLoading(false);
        if(server_response.status === "OK"){
            modifiedUser.callback && modifiedUser.callback(); // Refresh user list if callback is provided
            setNotify(<Notification type="success" message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }
        handleClose(); // Close the modal
    };

    const handleClose = () => {
        setModifiedUser({show: false, user: null, callback: null});
        setRoleId(null); // Reset roleId when closing the modal
    }

    const renderRoles = () =>{

       const options = [];
        if (Array.isArray(userRoles)) {
            userRoles.map((item, key) =>
                options.push({ label: item.role_name, value: item.role_id })
            );
        }

        return <TextInput
                label="Select Role"
                type="select"
                value={roleId}
                onChange={(role) => setRoleId(role.value)}
                options={options}
                placeholder="Select a role"
                wrap
                leftComponent={<i className="fa fa-user-tag"></i>}
                leftIcon={true}
            />
    }
  

    return (
        <BsModal
            show={modifiedUser.show}
            onClose={handleClose}
            title="Change User Role"
            footer={
                <>
                  {loading && <ActivityLoader />}
                  {!loading && <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                        >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirm}
                        disabled={!roleId}
                        >
                        <i className="fa fa-check-circle mr-1"></i> Confirm Role
                    </button>
                    </>}
               </>
            }
            >
            <div className="">
            {renderRoles()}
            
            <p className="text-muted mt-2">
                Please select a role to assign the selected user.
            </p>

            </div>

        </BsModal>
    );
};

export default PopChangeUserRole;
